import axios from '../utils/axios';

export default function getDomainCompanies(adminId, domain) {
    return (
        axios.get(`/admin/${adminId}/domain-companies`, { params: { domain, statusNotEq: 0 } })
            .then(res => {
                return res.data;
            }).catch(err => {
                return err;
            })
    )
}